import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '__services/http.service';
import { UserProfileService } from '~/app/core/services';

@Component({
  standalone: true,
  template: '',
})
export default class MicrosoftCallbackPage implements OnInit {
  constructor(
    private router: Router,
    private http: HttpService,
    private userProfileService: UserProfileService,
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const idToken = params.get('id_token');

      if (!idToken) {
        throw new Error('Microsoft token not found');
      }

      const res: any = await this.http
        .post(
          '/auth/microsoft-login',
          { redirectUrl: window.location.origin },
          { headers: { Authorization: `Bearer ${idToken}` } },
        )
        .toPromise();

      localStorage.setItem('access_token', res.AccessToken);

      this.http.get('/profiles', {}, { login: 'login' }).subscribe({
        next: (profile: any) => {
          this.userProfileService.setUserFeature(profile.role.modules);
          this.userProfileService.setUserProfile(profile);
          if (profile.language) {
            localStorage.setItem('userLang', profile.language);
          }
          this.router.navigate(['/dashboard']);
        },
        error: (err: any) => {
          const message =
            err?.error?.error?.message || err?.message || 'Login failed';
          this.router.navigate(['/auth/login'], {
            queryParams: { errorMsg: message },
          });
        },
      });
    } catch (err: any) {
      console.error(err);
      const message =
        err?.error?.error?.message || err?.message || 'Microsoft login failed';
      this.router.navigate(['/auth/login'], {
        queryParams: { errorMsg: message },
      });
    }
  }
}
